import { render, staticRenderFns } from "./TopBackground.vue?vue&type=template&id=4b20a190&scoped=true&"
import script from "./TopBackground.vue?vue&type=script&lang=js&"
export * from "./TopBackground.vue?vue&type=script&lang=js&"
import style0 from "./TopBackground.vue?vue&type=style&index=0&id=4b20a190&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b20a190",
  null
  
)

export default component.exports